import CommunityAmenitiesSection from '@/components/CommunityAmenitiesSection/CommunityAmenitiesSection';
import FAQsSection from '@/components/FAQsSection/FAQsSection';
import FeaturedFloorPlansSection from '@/components/FeaturedFloorPlansSection/FeaturedFloorPlansSection';
import Hero from '@/components/Hero/Hero';
import HomeCTASection from '@/components/HomeCTASection/HomeCTASection';
import { useAppContext } from '@/contexts/AppContext';

const Home = () => {
  const { community } = useAppContext();

  return (
    <div>
      <Hero
        title={community?.websiteDetails?.heroSectionMainText ?? ''}
        subtitle={community?.websiteDetails?.heroSectionSubtext ?? ''}
      />

      <FeaturedFloorPlansSection />

      <CommunityAmenitiesSection />

      <FAQsSection />

      <HomeCTASection />
    </div>
  );
};

export default Home;
